import { Pipe, PipeTransform } from '@angular/core';

import { IArticle } from '../../prisma-xs/models/article.model';
import { IGroupInCatalogue } from '../../prisma-xs/models/prisma-xs.model';
import {
  findTheMaximumValueInArrayForAttribute,
  findTheMinimumValueInArrayForAttribute,
  getSmallestArticle
} from '../helpers/pragma.helper';
import { KitType } from '../../shared/models/prisma-xs.model';
import { extractTypesFromArticle } from '../helpers/product.helper';
import { ProductRangesConstants } from '../models/product-ranges.constants';

@Pipe({
    name: 'prismaProducts',
    standalone: false
})
export class PrismaProductsPipe implements PipeTransform {

  transform(articles: IArticle[], kitType: KitType): IGroupInCatalogue[] {
    if (!Array.isArray(articles)) {
      return [];
    }

    const types = extractTypesFromArticle(articles, kitType);

    return types.map(type => {
      const articlesOfType = articles.filter(article => article.productType === type);
      const maxFields = findTheMaximumValueInArrayForAttribute(articlesOfType, 'width');
      const maxRows = findTheMaximumValueInArrayForAttribute(articlesOfType, 'height');
      const smallestArticle = getSmallestArticle(articlesOfType);

      const minFields = findTheMinimumValueInArrayForAttribute(articlesOfType, 'width');
      const minRows = findTheMinimumValueInArrayForAttribute(articlesOfType, 'height');

      return {
        group: {
          name: type,
          kitTypeId: smallestArticle.kitTypeId,
          order: smallestArticle.kitOrder,
          image: smallestArticle.picture3D,
          articles: articlesOfType.map(article => {
            return  { ...article, maxRows, maxFields, minFields, minRows };
          }).sort((a, b) => {
            if (this.kitHasSpecialPriority(a.ref)) {
              // Inside of Utility metering	group, 'SZMT1381M' kit needs to be at the first place,
              // because it's planned to replace all other kits in this group and stay as the only one
              return -1;
            }
            return (a?.widget?.width - b?.widget?.width) || (a?.widget?.height - b?.widget?.height);
          })
        },
        expanded: false
      };
    }).sort((a, b) => {
      if (a?.group.order > b?.group.order) {
        return 1;
      } else {
        return -1;
      }
    });
  }

  kitHasSpecialPriority(reference: string) {
    return reference === ProductRangesConstants.INSTALLATION_KIT_1_METER;
  }
}
